// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","shareMediaButtonWrapper":"_3VY2-","shareSocialMedia":"_3wGnP","text":"_2hFeU","titleShare":"z-9QW"};